import Axios from "axios";

export default function TypeProgram(selectedType){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'selectTypeTest',
            selectedType
        }
    });
    return response;
}